import {Title, Text, Date, Border,Content, ImgContainer, Btn, Img} from './styles';

const BlockTemplate = (props) => {

    return (
        <>
            <Border/>
            <Title>{props.title}</Title>
            <Content image={!!props.image}>
                {props.img && 
                    <ImgContainer>
                        <img alt='avatar' src={props.img}/>
                    </ImgContainer>
                }
                <div>
                    {props.texts.map((text) => (
                        <Text image={!!props.image}>{text}</Text>
                    ))}
                </div>
                {props.image && <Img alt='image' src={props.image}/>}
            </Content>
            {props.date && <Date>{props.date}</Date>}
            {props.button && props.href && 
                <Btn href={props.href} target='_blank'>{props.button}</Btn>
            }
        </>
    )
}

export default BlockTemplate;